/**
 * Vanilla tRPC Client
 * For use in Zustand stores and non-React code
 */
import { createTRPCClient, httpBatchLink } from '@trpc/client'
import type { AppRouter } from '../../../server/api/src/trpc/routers/_app'
import { getStoredTokens, refreshTokens, saveTokens, isTokenExpired } from './cognito-auth'

const API_BASE = import.meta.env.VITE_API_URL

async function getAccessToken(): Promise<string | null> {
  const stored = getStoredTokens()
  if (!stored) return null

  // Refresh if expired (with 60s buffer)
  if (isTokenExpired(stored.expiresAt - 60000)) {
    try {
      const newTokens = await refreshTokens(stored.refreshToken)
      saveTokens({
        ...newTokens,
        refreshToken: stored.refreshToken,
      })
      return newTokens.accessToken
    } catch {
      return null
    }
  }

  return stored.accessToken
}

export const trpcClient = createTRPCClient<AppRouter>({
  links: [
    httpBatchLink({
      url: `${API_BASE}/trpc`,
      async headers() {
        const token = await getAccessToken()
        return token ? { Authorization: `Bearer ${token}` } : {}
      },
    }),
  ],
})
